import axios from 'axios'
import { useCallback, useState } from 'react'

import { useLocalStorage } from '@front/logic/hooks'
import { isApp } from '@front/logic/others'

import { registerOneSignalUrl } from '../../service-notification'

export const useOneSignalRegistration = () => {
  const [registered, setRegistered] = useState(false)
  const [infoOnesignal] = useLocalStorage('infoOnesignal')
  const [accessToken] = useLocalStorage('accessToken')
  const [idLanguage] = useLocalStorage('idLanguageOnesignal')

  return {
    registeredOnOneSignal: registered,
    registerOnOneSignal: useCallback(async () => {
      // do not continue if not in app or one signal info is not defined
      if (!isApp() || !infoOnesignal) {
        return
      }

      try {
        // do not continue if oneSignalUserId is not yet defined - it avoids bad request errors from the server
        const parsedInfoOneSignal = JSON.parse(infoOnesignal)
        if (!parsedInfoOneSignal.oneSignalUserId) {
          return
        }

        await axios.post(
          registerOneSignalUrl,
          {
            idLanguage,
            os: parsedInfoOneSignal.os,
            osVersion: parsedInfoOneSignal.osVersion,
            playerId: parsedInfoOneSignal.oneSignalUserId,
            timeZone: parsedInfoOneSignal.timeZone,
            subscribed: parsedInfoOneSignal.oneSignalSubscribed,
          },
          {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: `Bearer ${accessToken}`,
            },
          },
        )
        setRegistered(true)
      } catch (err) {
        console.error(err)
      }
    }, [infoOnesignal, accessToken, idLanguage]),
  }
}
